import './App.css';
import Game from './components/Game/Game';

function App() {
  return (
    <main className="App">
      <Game /> 
    </main>
  );
}

export default App;
